var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMustPlayOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50236_25146)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32129 14.1219H13.3213L15.5377 4.28367C15.5389 4.28367 15.5401 4.28367 15.5412 4.28366C15.5462 4.28364 15.5511 4.28359 15.5561 4.28351C16.2535 4.27217 16.8174 3.67963 16.8213 2.94695C16.8233 2.55568 16.6652 2.20253 16.4113 1.95544C16.1834 1.73375 15.8784 1.59742 15.5426 1.59549C14.8325 1.59142 14.2537 2.18988 14.2498 2.93219C14.2491 3.05642 14.2646 3.17681 14.2942 3.29117C14.393 3.6734 14.6492 3.98842 14.986 4.15508C15.1505 4.23652 15.3344 4.28254 15.5285 4.28365L15.5322 4.28367L11.8213 6.625L8.83143 2.8913L5.82129 6.625L2.11257 4.19298C2.29982 4.19218 2.47772 4.14949 2.63807 4.07337C2.98127 3.91046 3.24412 3.59443 3.34635 3.20829C3.37603 3.09618 3.39217 2.97817 3.39281 2.85627C3.39671 2.11395 2.82422 1.50888 2.11412 1.50481C1.78638 1.50293 1.48661 1.6294 1.25843 1.83912C0.9922 2.0838 0.823408 2.4418 0.821309 2.84151C0.817411 3.58383 1.3899 4.1889 2.1 4.19297L2.11007 4.19299L4.32129 14.1219ZM4.37699 7.47164L5.52398 12.6219H12.1216L13.2805 7.47793L11.4882 8.60877L8.82748 5.28612L6.1357 8.62493L4.37699 7.47164ZM7.61417 2.01124C7.83276 2.47255 8.28797 2.82251 8.77968 2.84958C8.79791 2.85058 8.8162 2.85114 8.83452 2.85125C8.8505 2.85134 8.86647 2.85108 8.88239 2.85049C9.37584 2.83207 9.83699 2.48773 10.062 2.02832C10.1524 1.84395 10.2047 1.64104 10.2058 1.43323C10.2097 0.69091 9.55959 0.00409304 8.84949 1.82328e-05C8.13939 -0.00405658 7.48216 0.675491 7.47826 1.41781C7.47717 1.62441 7.52675 1.82673 7.61417 2.01124Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50236_25146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.821289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustPlayOutlined);
export default __webpack_public_path__ + "static/media/mustPlayOutlined.5dc2ec7b.svg";
export { ForwardRef as ReactComponent };